import axios from 'axios'
import { getHandle } from '../util'

const getConfig = customerId => {
  return {
    baseURL: WISHLIST_URL,
    params: { handle: getHandle(SHOPIFY_DOMAIN), customerId },
    headers: {
      'Content-Type': 'application/json',
    },
  }
}

export const loadWishlist = customerId =>
  axios
    .get('legacy', getConfig(customerId))
    .then(response => {
      return response
    })
    .catch(function(error) {
      console.log('error is getting wishlist', error)
    })

export const addToWishlist = (productHandle, customerId) =>
  axios
    .post('legacy/add', { productHandle }, getConfig(customerId))
    .then(response => {
      return response
    })
    .catch(function(error) {
      console.log('error in adding to wishlist', error)
    })

export const removeFromWishlist = (productHandle, customerId) =>
  axios
    .post('legacy/remove', { productHandle }, getConfig(customerId))
    .then(response => {
      return response
    })
    .catch(function(error) {
      console.log('error in removing from wishlist', error)
    })
